class ValidateForm {
	constructor(formEl) {
		this.formEl = document.querySelector(formEl)
		this.init()		
	}
	init() {
		
		this.formEl.addEventListener('submit', e => {
			this.validate(e)
		})

	}
	validate(ev) {
		ev.preventDefault()
		let errors = false
		const validationContainers = this.formEl.querySelectorAll('.validation')
		const requiredFields = this.formEl.querySelectorAll("input[required]")
		validationContainers.forEach(c => {
			console.log(c);
			c.style.display = "none"
		})

		requiredFields.forEach(field => {
			if ((field.type === 'checkbox' && !field.checked) || (field.type === 'email' && !this.isValidEmail(field.value))) {
				if(field.parentNode.querySelector('.validation')) field.parentNode.querySelector('.validation').style.display = "block"
				errors = true
			} else {
				if(field.parentNode.querySelector('.validation')) field.parentNode.querySelector('.validation').style.display = ""
			}

		})

		
		if (!errors) {
			
			if (this.formEl === ".finder__contact-form") {

				let reqBody = {
				}
				Object.keys(this.syForm.elements).forEach(key => {
					let element = this.syForm.elements[key];
					reqBody[element.name] = element.value;
				})

				console.log(reqBody);

				jQuery.ajax({
					url: "https://hooks.zapier.com/hooks/catch/9807300/bzqu5vx/",
					type: "post",
					data: JSON.stringify(reqBody),
					success: function (e) {
						// Redirect to another success page
						if (e.status === "success") {
	
							this.formEl.innerHTML = "<h2>Vielen Dank für Deine Anfrage.</h2><p>Wir melden uns in Kürze.</p>"
							console.log(e);
							
	
						} else {
							this.formEl.innerHTML = "<h2>Deine Anfrage konnte nicht gesendet werden.</h2><p>Bitte versuche es erneut.</p>"
						}
						this.formEl.scrollIntoView()
					},
					error: function (e) {
						console.log(e);
					}
				})

			} else {
				this.formEl.submit()				
			 }
		}
	}
	isValidEmail(em) {
		const res = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  		return res.test(em);
	}
}

window.addEventListener('DOMContentLoaded', () => {

	if (document.querySelector('.newsletter__form')) {
		// document.querySelector('.newsletter__form').addEventListener('submit')
		const FormValidation = new ValidateForm('.newsletter__form')
	}

	// if (document.querySelector('.finder__contact-form')) {
	// 	document.querySelector('.finder__contact-form').addEventListener('submit', function (e) {
	// 		e.preventDefault();
	// 		const AgenturFinderForm = new ValidateForm('.finder__contact-form')
	// 	 })
	// }
	
})

window.addEventListener('wpcf7mailsent', (e) => { 
	if (e.target === document.querySelector('.form__modal form')) {
		location.href="https://trendreport2022.growdigital.group/"
	}
	if (e.target === document.querySelector('.trendreport-kontakt form')) {
		location.href="/trendreport-danke/"
	}
})

const showFormModal = (el) => { 
	el.classList.add('active')
}

window.addEventListener('DOMContentLoaded', () => { 

	// if (document.getElementById('trendreport-bestellung')) {
	// 	document.querySelector('#trendreport-bestellung a').addEventListener('click', e => { 
	// 		e.preventDefault()
	// 		showFormModal(document.querySelector('.form__modal '))
	// 	})
	// }

})

const closeFormModal = (el) => {
	el.classList.remove('active')
}


